<form [formGroup]="moduleForm" data-testid="settings-module-card">
    <form-section [subtitle]="subtitle(1767)">
        <form-item>
            <form-label [label]="subtitle(1633)" [leftSide]="true"></form-label>
            <form-text [subtitle]="settings.selectedModule.version"></form-text>
        </form-item>
        <form-item>
            <form-label [label]="subtitle(1188)"
                        [for]="'Module'"
                        [leftSide]="true"></form-label>
            <form-text-input [inputControl]="moduleNameControl"
                             [id]="'Module'"
                             [placeholder]="subtitle(1188)">
            </form-text-input>
        </form-item>
        <form-item>
            <form-label [label]="subtitle(2972)"
                        [for]="'AdditionalInformation'"
                        [leftSide]="true"></form-label>
            <form-text-input [inputControl]="additionalInformationControl"
                             [id]="'AdditionalInformation'"
                             [placeholder]="subtitle(2972)">
            </form-text-input>
        </form-item>
        <form-item>
            <form-label [label]="subtitle(3511)" [leftSide]="true"></form-label>
            <form-checkbox
                    [inputControl]="moduleDefaultControl"></form-checkbox>
        </form-item>
    </form-section>
    <form-section [subtitle]="subtitle(7933)">
        @if (parameters.urlCompany !== 'polypipe') {
            <form-item>
                <form-label [label]="subtitle(5191)"
                            [leftSide]="true"></form-label>
                <form-checkbox [inputControl]="postcodePolicyControl"
                               [disabled]="isPostCodePolicyAccepted()">
                </form-checkbox>
            </form-item>
        }
        @if (isPostCodePolicyAccepted()) {
            <form-item>
                <form-label [label]="subtitle(1929)"
                            [leftSide]="true"></form-label>
                <country-list [inputControl]="countryControl"></country-list>
            </form-item>
            <form-item>
                <form-label [label]="subtitle(1930)"
                            [for]="'ZipCode'"
                            [leftSide]="true"></form-label>
                <form-text-input [inputControl]="zipCodeControl"
                                 [id]="'ZipCode'"
                                 [placeholder]="subtitle(1930)">
                </form-text-input>
            </form-item>
        }
        <form-item>
            <form-label [label]="subtitle(1801)" [for]="'timeZone'"
                        [leftSide]="true"></form-label>
            <time-zones-list [inputControl]="timeZoneControl"
                             [id]="'timeZone'"></time-zones-list>
        </form-item>
        <form-item [flexEnd]="true">
            <form-button [subtitle]="subtitle(2964)"
                         (click)="updateModuleData()">
            </form-button>
        </form-item>
    </form-section>
</form>
